import Vue from 'vue'

function parseLocalDate (value) {
  if (!value) return new Date(NaN)
  const date = new Date(value)
  if (isNaN(date)) return date
  const berlinStr = date.toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' })
  const [year, month, day] = berlinStr.split('-')
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
}

function timeFormat (value, vm) {
  let date = new Date(value)
  let options = {
    hour: '2-digit',
    minute: '2-digit'
  }
  return date.toLocaleTimeString(Vue.config.lang, options)
}

export default {
  parseLocalDate,
  filters: {
    dateFormat (value, vm) {
      let date = parseLocalDate(value)
      let options = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }
      return date.toLocaleDateString(Vue.config.lang === 'en' ? 'en-UK' : Vue.config.lang, options)
    },
    timeFormat (value, vm) {
      let date = new Date(value)
      let options = {
        hour: '2-digit',
        minute: '2-digit'
      }
      return date.toLocaleTimeString(Vue.config.lang, options)
    },
    currencyFormat (value, currency) {
      let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency
      })
      return formatter.format(value)
    },
    travelersString (obj, vm) {
      let str = obj.adults.length + ' ' + vm.$i18n.tc('ibe.adults', obj.adults.length)
      if (obj.children.length && obj.infants.length) {
        str += ', ' + obj.children.length + ' ' + vm.$i18n.tc('ibe.children', obj.children.length)
        str += ' & ' + obj.infants.length + ' ' + vm.$i18n.tc('ibe.infants', obj.infants.length)
      } else if (obj.children.length) {
        str += ' & ' + obj.children.length + ' ' + vm.$i18n.tc('ibe.children', obj.children.length)
      } else if (obj.infants.length) {
        str += ' & ' + obj.infants.length + ' ' + vm.$i18n.tc('ibe.infants', obj.infants.length)
      }
      return str
    },
    travelerString (obj, vm) {
      let birthdateString = ''
      let options = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }
      let dateTimeFormatObj = new Intl.DateTimeFormat(Vue.config.lang, options)
      if (obj.birthdate !== '') {
        let date = parseLocalDate(obj.birthdate)
        birthdateString = ' ' + vm.$i18n.t('ibe.text_born') + ' ' + dateTimeFormatObj.format(date)
      }
      return obj.salutation + ' ' + obj.lastname + ', ' + obj.firstname + birthdateString
    },
    durationString (obj, vm) {
      let dateHotelFrom = parseLocalDate(obj.dateHotelFrom)
      let dateHotelTo = parseLocalDate(obj.dateHotelTo)
      let durationNights = Math.round((dateHotelTo - dateHotelFrom) / (1000 * 3600 * 24))
      let durationDays = durationNights + 1
      return vm.$i18n.t('ibe.text_duration', { days: durationDays, nights: durationNights })
    },
    airportString (obj, vm) {
      return obj ? vm.$i18n.t('ibe.flight') + ' ' + obj.text.airport + (obj.text.airline !== '' ? ' (' + obj.text.airline + ')' : '') : ''
    },
    arrivalString (obj, vm) {
      if (obj && obj.ibeData.type === 'FLIGHT') {
        let strTime = ''
        if (obj.segments.length > 0) {
          strTime = timeFormat(obj.segments[0].dateFrom)
          return vm.$i18n.t('ibe.text_flight', { route: obj.text.airport, service: obj.text.serviceName, time: strTime })
        }
        return obj.text.airport
      } else if (obj && obj.ibeData.type === 'SELF') {
        return vm.$i18n.t('ibe.self_arrival')
      } else if (obj && obj.ibeData.type === 'REQ') {
        return vm.$i18n.t('ibe.req_arrival')
      } else {
        return ''
      }
    },
    returnString (obj, vm) {
      if (obj && obj.ibeData.type === 'FLIGHT') {
        let strTime = ''
        if (obj.segments.length > 0) {
          strTime = timeFormat(obj.segments[0].dateFrom)
          return vm.$i18n.t('ibe.text_flight', { route: obj.text.airport, service: obj.text.serviceName, time: strTime })
        }
        return obj.text.airport
      } else if (obj && obj.ibeData.type === 'SELF') {
        return vm.$i18n.t('ibe.self_return')
      } else if (obj && obj.ibeData.type === 'REQ') {
        return vm.$i18n.t('ibe.req_return')
      } else {
        return ''
      }
    },
    flightDateString (obj, vm) {
      let dateFrom = parseLocalDate(obj.dateFrom)
      let dateTo = parseLocalDate(obj.dateTo)
      let options = {
        month: '2-digit',
        day: '2-digit',
        weekday: 'short'
      }
      if (dateFrom.toLocaleDateString(Vue.config.lang, options) === dateTo.toLocaleDateString(Vue.config.lang, options)) {
        return dateFrom.toLocaleDateString(Vue.config.lang, options)
      } else {
        return dateFrom.toLocaleDateString(Vue.config.lang, options) + ' - ' + dateTo.toLocaleDateString(Vue.config.lang, options)
      }
    },
    flightTimeString (obj, vm) {
      let timeFrom = new Date(obj.dateFrom)
      let timeTo = new Date(obj.dateTo)
      let options = {
        hour: '2-digit',
        minute: '2-digit'
      }
      if (timeFrom.toLocaleTimeString(Vue.config.lang, options) === '00:00' && timeTo.toLocaleTimeString(Vue.config.lang, options) === '00:00') {
        return vm.$i18n.t('ibe.text_no_flight_time')
      } else {
        return vm.$i18n.t('ibe.text_flight_time', { timeFrom: timeFrom.toLocaleTimeString(Vue.config.lang, options), timeTo: timeTo.toLocaleTimeString(Vue.config.lang, options) })
      }
    },
    objectString (obj) {
      return obj
    }
  },
  create () {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}
